import { useEffect } from "react";

import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { DistributionComponent } from "../../components/info/DistributionComponent";
import { ContainerComponent } from "../../components/ui";
import { setShowSearch } from "../../store/appConfigsSlice";

const DistributionPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setShowSearch(false));
  }, []);

  return (
    <ContainerComponent>
      <DistributionComponent />
    </ContainerComponent>
  );
};

export default withTranslation()(DistributionPage);
